export const STATUS_COLORS: Record<string, { bg: string; color: string }> = {
    onboarded: { bg: '#22c55e', color: '#ffffff' },
    passed: { bg: '#fee2e2', color: '#dc2626' },
    rejected: { bg: '#fee2e2', color: '#dc2626' },
    'deal ongoing': { bg: '#e1ffe1', color: '#49a71b' },
    'deal running': { bg: '#e1ffe1', color: '#49a71b' },
    new: { bg: '#dbeafe', color: '#2563eb' },
    qualified: { bg: '#dbeafe', color: '#2563eb' },
};

export type SortKey =
    | 'orgName'
    | 'leadStatus'
    | 'relationshipStatus'
    | 'revenue'
    | 'ebitdaPct'
    | 'existingDebt'
    | 'equityRaised'
    | 'investors'
    | 'state'
    | 'similarityScore';
export type SortDir = 'asc' | 'desc';

export const COLUMNS = [
    { key: 'orgName', label: 'Entity', sortable: true, width: '180px', numeric: false },
    { key: 'similarityScore', label: 'Similarity Score', sortable: true, width: '120px', numeric: true },
    { key: 'leadStatus', label: 'Lead Status', sortable: true, width: '120px', numeric: false },
    { key: 'relationshipStatus', label: 'Relationship Status', sortable: true, width: '150px', numeric: false },
    { key: 'revenue', label: 'Revenue', sortable: true, width: '100px', numeric: true },
    { key: 'ebitdaPct', label: 'EBITDA %', sortable: true, width: '90px', numeric: true },
    { key: 'existingDebt', label: 'Existing Debt', sortable: true, width: '120px', numeric: true },
    { key: 'investors', label: 'Top Investors', sortable: true, width: '160px', numeric: false },
    { key: 'equityRaised', label: 'Equity Raised', sortable: true, width: '110px', numeric: true },
    { key: 'state', label: 'State', sortable: true, width: '160px', numeric: false },
] as const;
